import { type PropsWithChildren, type ReactNode } from 'react';
import { type TemplateAiTutor } from '@/shared/components/Chatbot';
import { Chip } from '@/ui_v3/components/chip/Chip';
import { cn } from '@/utils/tailwind.util';
interface Props {
  aiTutors: (TemplateAiTutor & {
    isNew: boolean;
  })[];
  selectedAiTutorId?: string;
  onSelectAiTutor: (id: string) => void;
  title?: ReactNode;
}
export const AiTutorList = ({
  aiTutors,
  selectedAiTutorId,
  onSelectAiTutor,
  title
}: Props) => {
  const hasTitle = Boolean(title);
  return <section className="flex size-full shrink-0 flex-col gap-2xs overflow-y-auto bg-neutral p-md tablet-sm:w-[420px] tablet-sm:px-lg" data-sentry-component="AiTutorList" data-sentry-source-file="AiTutorList.tsx">
      {hasTitle ? <p className="pb-2xs text-left text-body-md-semibold text-default">
          {title}
        </p> : null}
      {aiTutors.map(tutor => <AiTutorItem key={tutor.id} isNew={tutor.isNew} avatarSrc={tutor.previewAvatarSrc} name={tutor.name} introduction={tutor.introduction} tags={tutor.tags} selected={tutor.id === selectedAiTutorId} onClick={() => onSelectAiTutor(tutor.id)} />)}
    </section>;
};
interface AiTutorItemProps {
  isNew: boolean;
  avatarSrc: string;
  name: string;
  introduction: string;
  tags: string[];
  selected?: boolean;
  onClick?: VoidFunction;
}
const AiTutorItem = (props: AiTutorItemProps) => <Card className={cn('w-full', {
  'border-strong': props.selected
})} onClick={props.onClick} data-sentry-element="Card" data-sentry-component="AiTutorItem" data-sentry-source-file="AiTutorList.tsx">
    <div className="shrink-0 p-[2px]">
      <img className="size-[42px] rounded-full" src={props.avatarSrc} alt={props.name} width={42} height={42} />
    </div>

    <div className="w-full py-4xs">
      <div className="flex w-full items-center justify-between gap-3xs">
        <h4 className="line-clamp-1 text-body-lg-bold">{props.name}</h4>
        {props.isNew && <Chip className="h-[22px] border-[#FFA2B4] text-[#FF0030]" size="xs" rounded="full">
            New
          </Chip>}
      </div>

      <p className="mb-xs mt-3xs line-clamp-2 pr-[17px] text-caption-lg-medium text-assistive">
        {props.introduction}
      </p>

      <ul className="flex gap-3xs">
        {props.tags.map((tag, i) => <li key={i} className="rounded-2xs border border-opacity-assistive bg-alternative px-3xs py-4xs text-caption-md-medium text-alternative">
            {tag}
          </li>)}
      </ul>
    </div>
  </Card>;
const Card = (props: PropsWithChildren<{
  className?: string;
  onClick?: VoidFunction;
}>) => <figure className={cn('bg-white py-sm px-md border border-alternative rounded-md cursor-pointer hover:bg-strong-alternative transition-colors flex gap-sm', props.className)} onClick={props.onClick} data-sentry-component="Card" data-sentry-source-file="AiTutorList.tsx">
    {props.children}
  </figure>;